export default "__VITE_ASSET__CBHSmJQg__"